import React, { useState } from "react";
import OperationCard from "../../operation/operationCard/OperationCard";
import { APP_COLORS } from "../../../utils/helpers";
import "./Performance.css";

const getApplicationName = (application) =>
  application?.nameAr ||
  application?.nameEn ||
  application?.app ||
  application?.appName ||
  application?.name ||
  "";

// The LUD application of the store, when it has one: without it there is no performance to show and the card is not rendered.
export const hasLudPerformance = (applications) =>
  Array.isArray(applications) &&
  applications.some((application) => getApplicationName(application).trim().toLowerCase() === "lud");

export default function Performance({
  lang,
  applications,
  store: dashboardStore,
  menu,
  loading = false,
}) {
  const [refreshKey, setRefreshKey] = useState(0);
  const ludApplication = Array.isArray(applications)
    ? applications.find(
        (application) =>
          getApplicationName(application).trim().toLowerCase() === "lud",
      )
    : undefined;

  // No LUD performance data and nothing loading: no empty card, no placeholder.
  if (!loading && !ludApplication) return null;
  if (loading && !ludApplication) {
    return (
      <section className="lud-dashboard-section lud-dashboard-performance">
        <div className="lud-performance-empty" role="status">
          <strong>{lang === "ar" ? "جاري تحميل أداء LUD" : "Loading LUD performance"}</strong>
          <span>{lang === "ar" ? "يرجى الانتظار قليلاً." : "Please wait a moment."}</span>
        </div>
      </section>
    );
  }

  const store = {
    id: dashboardStore?.id || "",
    storeName: dashboardStore?.businessName || dashboardStore?.name || "",
  };
  const app = { id: ludApplication.id || "", app: "LUD" };
  const filters = {
    appName: "LUD",
  };

  return (
    <section className="lud-dashboard-section lud-dashboard-performance">
      <div>
        <OperationCard
          key={`${store.id}-${app.id || app.app}`}
          menu={menu}
          store={store}
          app={app}
          color={APP_COLORS.LUD || "var(--ui-border)"}
          filters={filters}
          refreshKey={refreshKey}
          setRefreshKey={setRefreshKey}
        />
      </div>
    </section>
  );
}
